'use es6';

import { getSelectedThreadId } from '../../selected-thread/selectors/getSelectedThreadId';
import { getMessageEditorStaging } from './getMessageEditorStaging';
import { createSelector } from 'reselect';
import { getStagingTextByThreadId } from '../operators/getStagingTextByThreadId';
export const getMessageEditorText = createSelector(getSelectedThreadId, getMessageEditorStaging, (selectedThreadId, messageEditorStaging) => getStagingTextByThreadId(selectedThreadId, messageEditorStaging));